import { useAlert } from 'context/alert';
import { Alert as AlertType } from 'context/alert';
import { AnimatePresence, m } from 'framer-motion';
import { useTranslation } from 'next-i18next';
import React from 'react';

export function AlertBar() {
  const { alerts, handleDismissAlert } = useAlert();
  return (
    <div className='flex justify-center items-center fixed top-[24px] left-1/2 right-auto -translate-x-1/2 z-50 w-full max-w-xl'>
      <AnimatePresence>
        {alerts.map((alert: AlertType, index) => (
          <Alert alert={alert} handleDismiss={() => handleDismissAlert(index)} key={alert.id} />
        ))}
      </AnimatePresence>
    </div>
  );
}

interface AlertProps {
  alert: AlertType;
  handleDismiss: () => void;
}

export function Alert({ alert, handleDismiss }: AlertProps) {
  const { t } = useTranslation('common');
  return (
    <m.div
      animate={{ opacity: 1, y: '0' }}
      className='flex font-bold text-white pli-2 plb-1 bg-alert-dark rounded-0.5 mli-2'
      exit={{ opacity: 0, y: '-50%' }}
      initial={{ opacity: 0, y: '-50%' }}
      role='alert'
      transition={{ ease: 'easeInOut' }}
    >
      <div className='pie-1'>
        <svg
          aria-hidden='true'
          className='fill-white h-3 w-3 shrink-0 select-none'
          focusable='false'
          viewBox='0 0 24 24'
        >
          <path d='M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z'></path>
        </svg>
      </div>
      <div className='text-13'>{alert.message}</div>
      <div className='flex items-center pis-1'>
        <button aria-label={t('giving.cta.dismiss_alert')} onClick={handleDismiss}>
          <svg
            aria-hidden='true'
            className='fill-white h-3 w-3 shrink-0 select-none'
            focusable='false'
            viewBox='0 0 24 24'
          >
            <path d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'></path>
          </svg>
        </button>
      </div>
    </m.div>
  );
}
